import React from "react";
import "../Assets/Css/TileWithoutImg.scss";
// import '../Assets/Css/Dashboard.css'

const TileWithoutImg = (props) => {
  return (
    <div className="tiles-no-image">
      <div className="tiles-container">
        <div className="tiles-content">
          <div className="custom-content">
            <div className="text-part">
              <p className="tiles-title pt-2">{props.title}</p>
              <div className="bottom-text">
                <h4>{props.stats}</h4>
                <span>{props.subtitle}</span>
              </div>
            </div>
            {props.image? <div className="image-block pt-2">
              <div className="image">
                <div className={`${props.image}`}></div>
              </div>
            </div> : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TileWithoutImg;
